import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'

export const findCompetition = async (id) => {
    return await axios.get(`${url}/leaderboard/competition/${id}`)
}

export const getAllCompetitions = async () => {
    return await axios.get(`${url}/leaderboard/competition/all`, {
        headers: HeadersWithCredentials(),
    })
}

export const getAllCompetitionsOpenThisMonth = async () => {
    return await axios.get(`${url}/leaderboard/competition/calendar-open-events`, {
        headers: HeadersWithCredentials(),
    })
}

export const getAllCompetitionsBySearchQuery = async (query, cancelToken) => {
    return await axios.get(`${url}/leaderboard/competition/search-query`, {
        headers: HeadersWithCredentials(),
        params: query,
        cancelToken,
    })
}

export const getAllCompetitionsForNewsletter = async ({
            start,
            end,
            dateField,
        }) => {
    return await axios.post(`${url}/leaderboard/competition/newsletter`,
        {
            start, end, dateField
        },
        {
        headers: HeadersWithCredentials(),
    })
}

export const getFutureCompetitions = async () => {
    return await axios.get(`${url}/leaderboard/competition/next`, {
        headers: HeadersWithCredentials(),
    })
}

export const CreateCompetition = async (
    name,
    type,
    category,
    location,
    longitude,
    latitude,
    country,
    timezone,
    eventStartDate,
    eventEndDate,
    orgaId,
) => {
    return await axios.post(
        `${url}/leaderboard/competition/create`,
        {
            orgaId,
            name,
            type,
            category,
            location,
            longitude,
            latitude,
            country,
            timezone,
            eventStartDate,
            eventEndDate,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const addJudge = async (competitionId, email) => {
    return axios.put(
        `${url}/leaderboard/competition/add-judge/${competitionId}`,
        { email },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const deleteJudge = async (competitionId, judgeId) => {
    return axios.delete(`${url}/leaderboard/competition/delete-judge/${competitionId}/${judgeId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const updateCompetition = async (id, data) => {
    return axios.put(`${url}/leaderboard/competition/${id}`, data, {
        headers: HeadersWithCredentials(),
    })
}

export const EditCompetitionName = async (competitionId, name) => {
    return await axios.put(
        `${url}/leaderboard/competition/${competitionId}`,
        {
            name,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const findCompetitionFees = async (competitionId) => {
    return await axios.get(`${url}/fees/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const findScoreTypes = async (boardId) => {
    return await axios.get(`${url}/leaderboard/competition/findScore/${boardId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const findCompetitionInfoForScoringAthlete = async (boardId) => {
    return await axios.get(`${url}/leaderboard/competition/info/for-scoring-athlete/${boardId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const findCompetitionByReservationId = async (reservationId) => {
    return await axios.get(`${url}/leaderboard/competition-by-reservation-id/${reservationId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const addCheckInAttendant = async (competitionId, email) => {
    return axios.put(
        `${url}/leaderboard/competition/add-check-in-attendant/${competitionId}`,
        { email },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const deleteCheckInAttendant = async (competitionId, judgeId) => {
    return axios.delete(`${url}/leaderboard/competition/delete-check-in-attendant/${competitionId}/${judgeId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const addMediaAccount = async (competitionId, email) => {
    return axios.put(
        `${url}/leaderboard/competition/add-media/${competitionId}`,
        { email },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const deleteMediaAccount = async (competitionId, mediaAccountId) => {
    return axios.delete(`${url}/leaderboard/competition/delete-media/${competitionId}/${mediaAccountId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const deleteCompetition = async (competitionId) => {
    return axios.delete(`${url}/leaderboard/competition/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}
